const navBarDashboard = [
  {
    icon: require('@/assets/new/icon_programs.svg?external'),
    text: 'programs',
    key: 'Programs',
    routeName: 'Programs',
    show: 'true',
  },
  {
    icon: require('@/assets/new/icon_dashboard.svg?external'),
    text: 'dealer-list',
    key: 'Dealer',
    routeName: 'Dealer-List',
    show: 'false',
  },
  {
    icon: require('@/assets/new/icon_appeal.svg?external'),
    text: 'forms',
    key: 'Forms',
    routeName: 'Field-Forms',
    show: 'false',
  },
  {
    icon: require('@/assets/new/icon_documents.svg?external'),
    text: 'Survey Interference',
    key: 'FieldSI',
    routeName: 'FieldSI',
    show: 'false',
  },
];

export default () => navBarDashboard;
